"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProductCardFactory = _interopRequireDefault(require("./ProductCardFactory"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ProductCardWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  margin-top: 20px;\n"])), _r10SourceLibrary.Mixins.advancedSpacing('padding', [0, 2]), _r10SourceLibrary.Mixins.respondTo.md(_r10SourceLibrary.Mixins.advancedSpacing('padding', [0, 7])));
var ComparisonProductSelectorItem = function ComparisonProductSelectorItem(_ref) {
  var selectedProduct = _ref.selectedProduct,
    setSelectedProduct = _ref.setSelectedProduct,
    onSelect = _ref.onSelect,
    selectOptions = _ref.selectOptions;
  var tier = selectedProduct.tier;
  return /*#__PURE__*/_react.default.createElement(ProductCardWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: _services.locale.localeString("Recommendation.".concat(tier)),
    paddingLevel: 2,
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_ProductCardFactory.default, {
    selectedProduct: selectedProduct,
    setSelectedProduct: setSelectedProduct,
    onSelect: onSelect,
    selectOptions: selectOptions
  })));
};
var _default = ComparisonProductSelectorItem;
exports.default = _default;